var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Automatischer Logout bei Inaktivität in "+_vm._s(_vm.convertedExpInSecCounter)+" Minuten. "),_c('BeforeLogoutDialog',{ref:"beforeLogoutDialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }